// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"894":"66a6d1e5","1483":"66a6d1e5","2234":"66a6d1e5","3421":"66a6d1e5","3808":"66a6d1e5","6244":"04eea54e","7379":"66a6d1e5","7518":"66a6d1e5","7932":"287b6056","8855":"04eea54e"}[chunkId] + ".chunk.css";
};